import StoreIcn from "./icons/StoreIcn";
import StoresIcn from "./icons/StoresIcn";
import UserIcn from "./icons/UserIcn";
import QuestionIcn from "./icons/QuestionIcn";
import { LogRegLogo } from "../util/LogRegLogo";
import {LeftOutlined} from "@ant-design/icons";
import React from "react";
import {Button} from "../account/misc/Button";

export enum RestaurantType {
  Single, Multiple, Personal, Other

}

const Types = [
  {type: RestaurantType.Single, label: "Single <span class='ln'>Restaurant</span>", color: "#fff9e3", icn: <StoreIcn />},
  {type: RestaurantType.Multiple, label: "Multiple <span class='ln'>Restaurants</span>", color: "#f3f9ed", icn: <StoresIcn />},
  {type: RestaurantType.Personal, label: "Student / <span class='ln'>Personal Use</span>", color: "#fee9e7", icn: <UserIcn />},
  {type: RestaurantType.Other, label: "Other <span class='ln'>Business</span>", color: "#edf7fa", icn: <QuestionIcn />},
]

export interface RegStepOneProps {
  onTypeSelect: (type: RestaurantType) => void;
  onSignIn: () => void;
  onBack: () => void;
}

export default function RegStepOne({onTypeSelect, onBack, onSignIn}: RegStepOneProps) {
  return (
    <div className={"step-type step full"}>
      <div className={'back'} onClick={onBack}><LeftOutlined/></div>
      <LogRegLogo/>
      <h2>Business Type?</h2>
      <h6>Already have an account? <Button type={'LinkPrimary'} className={'sign-in-link'} onClick={onSignIn}>Sign in</Button></h6>
      <ul>
        {Types.map(it =>
          <li key={it.type}>
            <button onClick={() => onTypeSelect(it.type)}>
              <span className={"bbl"} style={{"backgroundColor": it.color}}>
                {it.icn}
              </span>
              <h3 dangerouslySetInnerHTML={{__html: it.label}}/>
            </button>
          </li>)}
      </ul>
    </div>
  );
}
